var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MasterdataTableContainer',{attrs:{"loading":false,"headers":_vm.headers,"table-data":_vm.tableData,"sort-by":_vm.sortBy,"sort-desc":true,"refetch":_vm.refetch,"actions":_vm.actions},on:{"row-click":_vm.onRowClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }